export default __webpack_public_path__ + "static/media/14@2x.81c87a55.png";